<template>
    <div class="dictionary-form">
        <form class="form" @submit.prevent="save()">
            <Spinner v-if="loading" />
            <div class="form-group">
                <label v-t="'editor.dictionary.form.sourceLabel'" class="form-group__label" />
                <FormInput
                    v-model="values.phrase"
                    :placeholder="$t('editor.dictionary.form.sourcePlaceholder')"
                    name="phrase"
                    required
                />
            </div>
            <div class="form-group">
                <label v-t="'editor.dictionary.form.replaceLabel'" class="form-group__label" />
                <FormTextarea
                    v-model="values.replace"
                    :placeholder="$t('editor.dictionary.form.replacePlaceholder')"
                    required
                />
            </div>
            <div class="form-group">
                <label class="form-group__label">Язык</label>
                <MultiSelect
                    v-model="values.languages"
                    :options="languages"
                    :form-value-text="item => item.label.original || item.label[$i18n.locale]"
                    with-filter
                    emit-prop="id"
                    empty-text="No languages"
                    style="width: 360px;"
                    required
                >
                    <template v-slot:default="{ item }">
                        {{ item.label.original || item.label[$i18n.locale] }}
                    </template>
                </MultiSelect>
            </div>
            <div class="form-group">
                <label v-t="'editor.dictionary.form.providerLabel'" class="form-group__label" />
                <CustomSelect
                    v-model="values.provider"
                    :options="providers"
                    :form-value-text="item => item.name"
                    emit-prop="id"
                    required
                >
                    <template #default="{ item }">
                        {{ item.name }}
                    </template>
                </CustomSelect>
            </div>
            <div class="dictionary-form__footer">
                <button v-t="'misc.add'" :disabled="loading" class="button button--medium" />
            </div>
            <ErrorList :error="error" />
        </form>
    </div>
</template>

<script>
import {
    FormInput,
    FormTextarea,
    CustomSelect,
    MultiSelect,
    ErrorList
} from '@speechki-frontend/shared/ui/forms';
import { mapGetters } from 'vuex';

export default {
    name: 'DictionaryForm',
    components: {
        FormInput,
        FormTextarea,
        CustomSelect,
        MultiSelect,
        ErrorList
    },
    props: {
        languages: {
            type: Array,
            default: () => []
        },
        providers: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        ...mapGetters(['bookLanguage'])
    },
    data() {
        return {
            loading: false,
            error: undefined,
            values: undefined
        };
    },
    created() {
        this.resetValues();
    },
    methods: {
        resetValues(payload = {}) {
            this.values = {
                phrase: '',
                replace: '',
                is_active: true,
                provider: '',
                languages: [],
                ...payload
            };
        },
        async save() {
            try {
                this.error = undefined;
                this.loading = true;

                await this.$http.post('/api/v1/admin/phrase_dictionary/phrases/', this.values);
                this.resetValues({
                    provider: this.values.provider,
                    languages: this.values.languages
                });
            } catch (err) {
                console.log(err);
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style src="./DictionaryForm.scss" lang="scss"></style>
